import { Link } from 'gatsby';
import type { FC } from 'react';
import type { AllStrapiCategoryOrAllStrapiSubCategory } from '../../../@types/gql/products-listing';
import { IoMdArrowDropright } from '@react-icons/all-files/io/IoMdArrowDropright';
import 'swiper/css';
import 'swiper/css/pagination';
import Swiper from '../../shared/swiper';

interface ProductCategoryListProps {
  category: string;
  categories: AllStrapiCategoryOrAllStrapiSubCategory;
}

const ProductCategoryList: FC<ProductCategoryListProps> = ({
  category,
  categories,
}) => {
  return (
    <div className="product-cate-list bg-[#F4F4F4]">
      <div className="container mx-auto">
        <div className="mobile-mode">
          <Swiper
            arrows={{
              right: (
                <IoMdArrowDropright className="-translate-x-10 text-4xl fill-gray-50 stroke-gray-50" />
              ),
              left: (
                <IoMdArrowDropright className="translate-x-10 text-4xl fill-gray-50 stroke-gray-50 rotate-180" />
              ),
            }}
            className="gap-2 px-6"
          >
            {categories.nodes?.map(({ Slug, Title }) => {
              return (
                <Link
                  className={`${category === Slug ? 'bg-action-btn text-gray-50' : ''} px-3.5 py-2.5 min-w-fit uppercase text-sm transition-smooth 
                  hover:bg-action-btn hover:text-white w-full text-center font-bold`}
                  key={Slug}
                  to={`/${Slug}`}
                >
                  {Title}
                </Link>
              );
            })}
          </Swiper>
        </div>
        <div className="flex flex-wrap justify-center gap-1 destop-mode">
          {categories.nodes?.map(({ Slug, Title }) => {
            return (
              <Link
                className={`${category === Slug ? 'bg-action-btn text-gray-50' : ''} px-3.5 py-2.5 uppercase text-sm transition-smooth 
                  hover:bg-action-btn hover:text-white sm:w-auto w-full text-center font-bold`}
                key={Slug}
                to={`/${Slug}`}
              >
                {Title}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductCategoryList;
